import './select'

export default [
    {
        path: '/subsidies',
        component: () => import('./index.vue'),
        children: [
            {
                path: 'add',
                component: () => import('./item/index.vue'),
            },
            {
                path: 'edit/:id',
                component: () => import('./item/index.vue'),
                props: true,
            },
            {
                path: 'edit/:id/:child',
                component: () => import('./item/index.vue'),
                props: true,
            },
        ]
    },
    {
        path: '/subsidies/:path',
        component: () => import('./index.vue'),
        props: true,
    },
]
